module.exports = __webpack_public_path__ + "static/media/jaune.4317a741.png";